import { RiArrowDropRightLine } from 'react-icons/ri';

import styled, { css, TColorProp } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { getThemeColor } from '~/common/utils/get-theme-color';
import { SPACING } from '~/common/constants/spacing';

export const Option = styled.li<{
  current: boolean;
  transparentBackground: boolean;
  hoverColor: TColorProp;
  paddingLeft?: string;
  iconHoverColor?: TColorProp;
  currentOpacity: number;
  backgroundColor?: TColorProp;
  hoverColorOpacity: number;
  currentColor?: TColorProp;
  withoutClick: boolean;
  $allowTitleWrap: boolean;
}>`
  pointer-events: ${({ withoutClick }) => (withoutClick ? 'none' : 'all')};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: ${({ $allowTitleWrap }) =>
    $allowTitleWrap ? 'normal' : 'nowrap'};
  padding: ${SPACING._8};
  gap: ${SPACING._6};
  border-radius: ${SPACING._4};
  transition: 200ms;
  background-color: ${({
    theme,
    current,
    backgroundColor,
    transparentBackground,
    currentColor,
    currentOpacity,
  }) =>
    transparentBackground
      ? theme.transparent
      : current
      ? currentOpacity
        ? hexToRgba(getThemeColor(theme, currentColor), currentOpacity)
        : getThemeColor(theme, currentColor)
      : getThemeColor(theme, backgroundColor)};

  min-height: 40px;
  height: ${({ $allowTitleWrap }) => ($allowTitleWrap ? 'auto' : '40px')};
  max-height: ${({ $allowTitleWrap }) =>
    $allowTitleWrap ? 'none' : '40px'};

  ${({ paddingLeft }) =>
    paddingLeft &&
    css`
      padding-left: ${paddingLeft};
    `}

  svg,
  div,
  span {
    transition: 200ms;
  }

  span {
    min-width: 0;
    overflow-wrap: ${({ $allowTitleWrap }) =>
      $allowTitleWrap ? 'anywhere' : 'normal'};
  }

  &:hover {
    ${({ hoverColor, hoverColorOpacity, current, theme }) =>
      current
        ? css`
            filter: brightness(1.2);
          `
        : css`
            background-color: ${hoverColorOpacity
              ? hexToRgba(getThemeColor(theme, hoverColor), hoverColorOpacity)
              : getThemeColor(theme, hoverColor)};
          `}

    svg {
      fill: ${({ iconHoverColor, theme }) =>
        getThemeColor(theme, iconHoverColor)} !important;
      color: ${({ iconHoverColor, theme }) =>
        getThemeColor(theme, iconHoverColor)} !important;
    }
  }
`;

export const CustomArrow = styled(RiArrowDropRightLine)<{
  to: 'top' | 'bottom';
}>`
  transition: 200ms;
  margin-left: auto;
  margin-top: 6px;
  ${({ to }) =>
    to === 'top'
      ? css`
          transform: rotate(-90deg);
        `
      : css`
          transform: rotate(90deg);
        `}
`;
